if (
    process.env.NODE_ENV !== "test" &&
    (!process.env.REACT_APP_CLIENT_ID ||
      !process.env.REACT_APP_AUTH0_DOMAIN ||
      !process.env.REACT_APP_AUTH0_SCOPE ||
      !process.env.REACT_APP_AUTH0_AUDIENCE ||
      !process.env.REACT_APP_AUTH0_CALLBACK ||
      !process.env.REACT_APP_BACKEND_URI)
  ) {
    throw new Error("Error in providing all necessary environment variables");
  }
  
  const fakeTestConfig = {
    AUTH0_AUDIENCE: "XXXXX",
    AUTH0_CLIENT_ID: "12456789",
    AUTH0_DOMAIN: "DOMAIN",
    AUTH0_SCOPE: "OPENID",
    AUTH0_CALLBACK: "/",
    REACT_APP_BACKEND_URI: "back_url"
  };
  
  const config = {
    AUTH0_AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE,
    AUTH0_CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
    AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN,
    AUTH0_SCOPE: process.env.REACT_APP_AUTH0_SCOPE,
    AUTH0_CALLBACK: process.env.REACT_APP_AUTH0_CALLBACK,
    REACT_APP_BACKEND_URI: process.env.REACT_APP_BACKEND_URI
  };
  
  const configBuilder = () => {
    if (process.env.NODE_ENV === "test") {
      return fakeTestConfig;
    }
    return config;
  };
  
  export default configBuilder();
  